export const DIALOG_WIDTH = '768px';